// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-Features-ReimbursementFlagsChips___flagsContainer--NJeHj {
  display: flex;
  gap: 8px;
  margin: 16px 0 8px 0;
}

.components-Features-ReimbursementFlagsChips___flagSuccess--n1dj4 {
  height: 32px;
  font-size: 13px;
  color: #ffffff;
  letter-spacing: 0;
  background: #4caf50;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  font-family: 'Roboto';
  font-weight: 600;
}

.components-Features-ReimbursementFlagsChips___flagWarning--pAyMJ {
  height: 32px;
  font-size: 13px;
  color: #ffffff;
  letter-spacing: 0;
  background: #ff9800;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  font-family: 'Roboto';
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./components/Features/ReimbursementFlagsChips.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB","sourcesContent":[".flagsContainer {\n  display: flex;\n  gap: 8px;\n  margin: 16px 0 8px 0;\n}\n\n.flagSuccess {\n  height: 32px;\n  font-size: 13px;\n  color: #ffffff;\n  letter-spacing: 0;\n  background: #4caf50;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 16px;\n  font-family: 'Roboto';\n  font-weight: 600;\n}\n\n.flagWarning {\n  height: 32px;\n  font-size: 13px;\n  color: #ffffff;\n  letter-spacing: 0;\n  background: #ff9800;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 16px;\n  font-family: 'Roboto';\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flagsContainer": `components-Features-ReimbursementFlagsChips___flagsContainer--NJeHj`,
	"flagSuccess": `components-Features-ReimbursementFlagsChips___flagSuccess--n1dj4`,
	"flagWarning": `components-Features-ReimbursementFlagsChips___flagWarning--pAyMJ`
};
module.exports = ___CSS_LOADER_EXPORT___;
